const defaultState = () => ({});

export default (state = defaultState(), { type, payload }) => {

    switch (type) {
        case "PREFERENCES:FETCH_START": {
            const { name } = payload;
            return { ...state, [name]: { ...state[name], loading: true, error: null } };
        }
        case "PREFERENCES:FETCH_ERROR": {
            const { name, error } = payload;
            return { ...state, [name]: { ...state[name], loading: false, error: error } };
        }
        case "PREFERENCES:FETCH_SUCCESS": {
            const { name } = payload;
            return {
                ...state,
                [name]: {
                    ...state[name],
                    initialLoaded: true,
                    loading: false,
                    error: null,
                    ...payload
                }
            };
        }
        case "PREFERENCES:SAVE_OR_UPDATE_LOCAL": {
            const { name, data } = payload;
            return {
                ...state,
                [name]: {
                    ...state[name],
                    loading: false,
                    error: null,
                    name,
                    data,
                }
            };
        }
        case "PREFERENCES:SAVE_OR_UPDATE_SUCCESS": {
            const { id, name, data } = payload;
            return {
                ...state,
                [name]: {
                    ...state[name],
                    loading: false,
                    error: null,
                    id,
                    name,
                    data,
                }
            };
        }
        default: {
            return state;
        }
    }
};
